module.exports = __webpack_public_path__ + "img/8.812b950b.svg";